import {Box} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import {ActionButton} from "../../../designSystem/components/ActionButton";
import {NAVIGATION_BAR_HEIGHT} from "../../../designSystem/tokens/spacing";

interface FormPageLayoutProps {
  height?: number;
  body: React.ReactNode;
  footer?: React.ReactNode;
  rightProfilePic?: string;
  showLeftGoBack?: boolean;
}

const BRAND_LOGO_URL = '/img/logo.png'
const PLACEHOLDER = <Box className="w-10 h-10" />
export const FormPageLayout = ({
  height = NAVIGATION_BAR_HEIGHT.MEDIUM,
  body,
  footer = null,
  rightProfilePic = '',
  showLeftGoBack = false,
}: FormPageLayoutProps) => {
  const navigate = useNavigate();

  const showLeftPlaceholder = rightProfilePic && !showLeftGoBack;
  const showRightPlaceholder = showLeftGoBack && !rightProfilePic;

  return (
    // background
    <Box className="mx-auto flex h-screen justify-between flex-col overflow-hidden max-w-lg shadow-xl bg-gray-100">
      {/* container */}
      <Box className="flex flex-col flex-1">

        {/* top bar */}
        <Box className="bg-[#377D9D] h-[63px] py-1 flex flex-row items-center">
          {showLeftPlaceholder && PLACEHOLDER}
          {showLeftGoBack && (
            <ActionButton
              dark
              iconName="fa-chevron-left"
              variant="ghost"
              onClick={() => navigate(-1)}
            />
          )}
          <img src={BRAND_LOGO_URL} alt="header" className="m-auto h-[50px]"/>
          {rightProfilePic && <img src={rightProfilePic} alt="Profile" className="w-10 h-10 rounded-full mr-4"/>}
          {showRightPlaceholder && PLACEHOLDER}
        </Box>

        {/* body */}
        <Box
          className="flex flex-col overflow-y-scroll gap-4"
          style={{height: `calc(100vh - ${height}px)`}} // cannot write in tailwind so must be defined with style
        >
          {body}
        </Box>

        {/* footer */}
        {footer &&
          <div className="bg-white border-t text-center p-4 shadow-2xl shadow-blue-300">
            {footer}
          </div>
        }
      </Box>
    </Box>
  )
}
